import React, { PureComponent } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import ReactList from 'react-list'
import { isiOS } from '../../../../constants'

import NewItem from '../NewItem'
import MassInvoice from '../../../../shared/modals/MassInvoice'

import { hasAccess, hasSubscriptionPermission, hasAccessToAssign } from '../../../../utils/auth'
import { translation } from '../../../../utils/helpers'

import { getArchivedOrders, updateOrderList, updateOrderListSingle, getOrdersNew, setOrdersFilter } from '../../../../actions/orders'
import { massInvoiceOrders, massMarkInvoiced } from '../../../../actions/invoicing'
import { triggerPopup } from '../../../../actions/backdrop'

import './index.scss'

// Elements
import DropDown from '../../../../shared/elements/dropDown'
import Grid from '../../../../shared/elements/grid'

class List extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
      items: [],
      pagination: {
        hasMore: true,
        isFetching: true,
        page: 1
      },
      assignBoxOut: false,
      GoToTop: false,
      newOrdersFilter: 0,
      massInvoice: {
        open: false,
        isLoading: false,
        orderGroup: {},
        orderGroupKey: null,
        response: null,
        itemsIsInvoicing: []
      }
      // dimensions: {
      //   width: 0,
      //   height: 0
      // }
    }
    this.renderItem = this.renderItem.bind(this)
    this.getItems = window.debounce(this.getItems, 500)
    this.app = null
    this.number = 85
    this.queryOrderId = 'undefined'
    this.scrollListener = window.debounce(this.scrollListener.bind(this), 500)
    this.toggleAssign = this.toggleAssign.bind(this)
    this.setSimpleSearch = this.setSimpleSearch.bind(this)
    this.setNewOrdersFilter = this.setNewOrdersFilter.bind(this)
    this.getNewOrdersFilter = this.getNewOrdersFilter.bind(this)
    // this.dimensionShow = this.dimensionShow.bind(this)
    // this.updateDimensions = this.updateDimensions.bind(this)

    // Mass Invoice
    this.onMassInvoiceClose = this.onMassInvoiceClose.bind(this)
    this.executeMassInvoice = this.executeMassInvoice.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.orders !== nextProps.orders || this.props.openStartStopId !== nextProps.openStartStopId) {
      this.getItems(nextProps)
    }
  }

  componentDidMount () {
    this._mounted = true
    this.getItems(this.props)
    this.attachListeners()
    this.queryOrderId = '' + this.props.router.location.query.orderid
    if (this.queryOrderId !== 'undefined') {
      this.number = 20000
    }
    let newOrdersFilter = this.getNewOrdersFilter()
    // window.addEventListener('resize', this.updateDimensions)
    // this.updateDimensions()
    this.setState({
      newOrdersFilter: newOrdersFilter
    })
  }

  checkForPopups () {
    let item = document.getElementsByClassName('poppedup padding')[0]
    if (item !== undefined) {
      let bounding = item.getBoundingClientRect()
      let app = document.getElementById('app')
      let windowWith = window.innerWidth
      let windowHeight = window.innerHeight

      if (bounding.left < 0) {
        if (windowWith > ((bounding.width * 2) + bounding.left)) {
          item.style.left = 0
        } else {
          let margin = (windowWith - bounding.width) / 2
          item.style.right = bounding.left - margin
        }
      }

      if (bounding.right < 0) {
        if (windowWith > ((bounding.width * 2) + bounding.right)) {
          item.style.right = 0
        } else {
          let margin = (windowWith - bounding.width) / 2
          item.style.left = bounding.right - margin
        }
      }

      if (bounding.top < 0) {
        app.scrollTop = app.scrollTop + bounding.top
      }
      let bottomOffset = windowHeight - (bounding.top + bounding.height)
      if (bottomOffset < 0) {
        let distance = bottomOffset * -1
        distance += app.scrollTop
        app.scrollTop = distance
      }
    }
  }

  componentWillUnmount () {
    this._mounted = false
    this.detachScrollListener()
  }

  attachListeners () {
    if (isiOS) {
      this.app = document.body
      document.addEventListener('scroll', this.scrollListener)
      document.addEventListener('resize', this.scrollListener)
    } else {
      this.app = ReactDOM.findDOMNode(document.getElementById('app'))
      this.app.addEventListener('scroll', this.scrollListener)
      this.app.addEventListener('resize', this.scrollListener)
    }
  }

  detachScrollListener () {
    if (isiOS) {
      document.removeEventListener('scroll', this.scrollListener)
      document.removeEventListener('resize', this.scrollListener)
    } else {
      this.app.removeEventListener('scroll', this.scrollListener)
      this.app.removeEventListener('resize', this.scrollListener)
    }

    this.app = null
  }

  resetPagination () {
    this.setState({
      pagination: {
        hasMore: true,
        isFetching: true,
        page: 1
      }
    })
  }

  setSimpleSearch (simpleSearch) {
    this.setState({
      simpleSearch: simpleSearch
    })
  }

  scrollListener () {
    if (this.app === null || typeof this.app === 'undefined') return null

    let distance = this.app.scrollHeight - this.app.scrollTop

    if (this.app.scrollTop > 500) {
      if (this.state.GoToTop !== true) {
        this.setState({
          GoToTop: true
        })
      }
    } else {
      if (this.state.GoToTop) {
        this.setState({
          GoToTop: false
        })
      }
    }

    if (distance < 2000 && this.state.pagination.hasMore) {
      this.loadMore(this.state.pagination.page + 1)
    }
  }

  // dimensionShow (dimensions) {
  //   let show = false
  //   dimensions.map((val, key) => {
  //     if (!show) {
  //       let higherThan = val[0]
  //       let lessThan = val[1]
  //       let width = this.state.dimensions.width
  //       if (width > higherThan && width <= lessThan) show = true
  //     }
  //   })
  //   return show
  // }

  loadMore (page) {
    if (this.state.pagination.isFetching || (!this.props.filter.process.Completed && this.state.simpleSearch == null)) return null
    this.setState({
      pagination: {
        ...this.state.pagination,
        isFetching: true
      }
    })

    // Data
    let filter = { ...this.props.filter }
    filter.process = { ...this.props.filter.process } // To not modify the same object ref. (caused the filter to "stick")
    filter.process.Completed = true
    filter = {
      ...filter,
      simpleSearch: this.state.simpleSearch
    }
    let data = {
      Count: 50,
      PageIdx: page,
      Filter: filter
    }
    // Call API
    this.props.getArchivedOrders(data).then((res) => {
      if (!this._mounted) return null
      if (res.data.length !== 0) {
        // Reset order query when showing additional archived orders to prevent browser jumping to top of list.
        let routeItem = window.LocalstorageStack.findFirst(['/orders'])
        if (routeItem !== null) {
          this.props.router.replace({
            pathname: '/orders',
            query: null
          })
        }

        // Orders
        let orders = JSON.parse(JSON.stringify(this.props.orders))
        res.data.map((item, k) => {
          orders[orders.length - 1].Orders.push(item)
        })
        this.props.updateOrderList(orders)
      }
      // Done getting items, set new items and page
      this.setState({
        pagination: {
          isFetching: false,
          page: page,
          hasMore: (res.data.length !== 0)
        }
      }, () => {
        if (this.state.pagination.hasMore) {
          setTimeout(() => {
            // window.toastr.success(translation('2250'), translation('13424'))
          }, 1000)
        }
      })
    }, () => {
      window.toastr.error(translation('2249'), translation('216'))
      // Done with errors, set page back and is still loading
      this.setState({
        pagination: {
          hasMore: true,
          isFetching: false,
          page: page--
        }
      })
    })
  }

  toggleAssign (type) {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    if (!hasAccessToAssign(this.props.auth)) return null
    if (type !== this.state.assignBoxOut) {
      this.setState({
        assignBoxOut: type
      })
    }
  }

  getItems (props) {
    const wait = (until, doWhile, doAfter) => {
      if (until() === true) return doAfter()
      if (doWhile !== null) doWhile()
      setTimeout(() => {
        wait(until, doWhile, doAfter)
      }, 500)
    }

    let items = []
    let indexCount = -1
    let skipToIndex = false
    let ArciveHeaderSplit = false
    let date = new Date()
    date.setDate(date.getDate() - (date.getDay() || 7) + 1)
    date.setHours(0)
    date.setMinutes(0)
    date.setMilliseconds(0)

    props.orders.map((orderGroup, key) => {
      let skipInsert = false
      if (!orderGroup.SkipCheck) {
        if (!props.filter.process.draft && orderGroup.DictionaryKey === 395) {
          skipInsert = true
        }
        if (!props.filter.process.Completed && !props.filter.process.CompletedThisWeek && orderGroup.DictionaryKey === 2703) {
          skipInsert = true
        }
        // if (!props.filter.process.InProcess) {
        if (!props.filter.process.InProcess && orderGroup.DictionaryKey !== 2703 && orderGroup.DictionaryKey !== 395) {
          let inprocess = [1, 2, 3, 4, 5, 6, 7]
          // if (inprocess.indexOf(parseInt(orderGroup.Title)) !== -1) {
          //   skipInsert = true
          // }
          if (inprocess.indexOf(parseInt(orderGroup.StepId)) !== -1) {
            skipInsert = true
          }
        }
      }
      if (!skipInsert) {
        if (orderGroup.Orders.length === 0) {
          // indexCount++
          if (!props.filter.process.Completed && orderGroup.DictionaryKey === 2703) {
            // orders = ''
            // indexCount--
          }
          if (orderGroup.DictionaryKey === 164) {
            if (props.filter !== undefined && props.filter.NewOrdersFilter !== undefined ||
              props.filter.NewOrdersFilter !== null || props.filter.NewOrdersFilter !== 0) {
              items.push(this.renderHeader(orderGroup, key))
            }
          }
        } else {
          if (orderGroup.DictionaryKey === 2703) {
            if (new Date(orderGroup.Orders[0].ArchiveDate) < date) {
              items.push(this.renderHeader(orderGroup, key))
              ArciveHeaderSplit = true
            } else {
              orderGroup.DictionaryKey = 2702
              items.push(this.renderHeader(orderGroup, key))
              orderGroup.DictionaryKey = 2703
            }
          } else {
            items.push(this.renderHeader(orderGroup, key))
          }

          indexCount++
          orderGroup.Orders.map((item, k) => {
            if (orderGroup.DictionaryKey === 2703 && !ArciveHeaderSplit && new Date(item.ArchiveDate) < date) {
              items.push(this.renderHeader(orderGroup, key + 1))
              ArciveHeaderSplit = true
              indexCount++
            }
            if (typeof this.queryOrderId !== 'undefined') {
              indexCount++
              if (item !== null && ('' + item.Id === this.queryOrderId || (item.LinkedOrders !== undefined && item.LinkedOrders.filter(e => '' + e.Id === this.queryOrderId).length > 0))) {
                skipToIndex = indexCount
              }
            }
            // Is invoice loading?
            const isInvoicing = this.state.massInvoice.itemsIsInvoicing.includes(item.Id)

            items.push(
              <NewItem
                router={this.props.router}
                toggleAssign={this.toggleAssign}
                key={item.OrderKey}
                item={item}
                index={k}
                step={key}
                checkForPopups={this.checkForPopups}
                isInvoicing={isInvoicing}
                onStartAsShopLogin={this.props.onStartAsShopLogin}
                openStartStopId={this.props.openStartStopId}
                hasOpendStatrStop={this.props.hasOpendStatrStop}
                // setSelectedItem={this.props.setSelectedItem}
                openAction={this.props.openAction}
                // forceRender={Math.random()}
              />)
          })
        }
      }
    })
    if (this._mounted) {
      this.setState({
        items: items,
        pagination: {
          ...this.state.pagination,
          isFetching: false
        }
      }, () => {
        if (this.state.pagination.hasMore && this.state.items.length < 25) {
          this.loadMore(this.state.pagination.page + 1)
        }
        // Note:  If an order was just booked, for some reason that would be the only order in the list for a short moment,
        //        which means skipToIndex would be set to 1, and queryOrderId would be cleared. Shortly after the full list of orders would be iterated,
        //        but scrolling would then not occur as the id was cleared. Quickfix: scroll and reset query only if skipToIndex > 1
        if (skipToIndex !== false && skipToIndex > 1) {
          if (this.refs.reactlist === undefined) {
            wait(() => { return this.refs.reactlist !== undefined }, null, () => {
              this.refs.reactlist.scrollTo(skipToIndex)
              this.queryOrderId = 'undefined'
            })
          } else if (this.refs.reactlist !== undefined) {
            this.refs.reactlist.scrollTo(skipToIndex)
            this.queryOrderId = 'undefined'
          }
        }
      })
    }
  }

  getHeaderIcon (info) {
    let imagePath = '/images/svgs/workscreen/'
    switch (info.DictionaryKey) {
      case 395:
        return <img src={imagePath + 'Draft-order-Black.svg'} />
      case 164:
        return <img src={imagePath + 'neworder.svg'} />
      case 208:
        let img = 'coating.svg'
        if (this.props.auth.departmentType === 1 && hasAccess([4], this.props.auth.user.UserType)) {
          img = 'bodywork.svg'
        }
        return <img src={imagePath + img} />
      case 163:
        return <img src={imagePath + 'delivered.svg'} />
      case 2702:
      case 2703:
        return <img src={imagePath + 'Completed-Black.svg'} />
      case 158:
        return <img src={imagePath + 'sanding.svg'} />
      case 161:
        return <img src={imagePath + 'coating.svg'} />
      case 96:
        return <img src={imagePath + 'pretreatment.svg'} />
      case 160:
        return <img src={imagePath + 'filler.svg'} />
      case 162:
        if (info.StepId === 6) {
          return <img src={imagePath + 'preparing.svg'} />
        } else if (info.StepId === 104) {
          return <img src={imagePath + 'clean.svg'} />
        }
        break
      case 702:
        return <img src={imagePath + 'moved-order.svg'} />
      case 617:
        return <img src={imagePath + 'demount.svg'} />
      case 618:
        return <img src={imagePath + 'reparation.svg'} />
      case 619:
        return <img src={imagePath + 'mount.svg'} />
      default:
        return null
    }
  }

  getNewOrdersFilter (e) {
    let found = false
    var items = JSON.parse(window.localStorage.getItem('newOrdersFilter'))
    var newOrdersFilter = e ? Number(e.target.value) : 0

    if (items && typeof items.push === 'function') {
      items.map(x => {
        if (x.userId === this.props.auth.user.UserId) {
          if (e) x.filter = newOrdersFilter
          else newOrdersFilter = x.filter
          found = true
        }
      })
    } else items = []

    if (!found) {
      items.push({userId: this.props.auth.user.UserId, filter: newOrdersFilter})
    }
    window.localStorage.setItem('newOrdersFilter', JSON.stringify(items))
    return newOrdersFilter
  }

  setNewOrdersFilter (e) {
    var newOrdersFilter = this.getNewOrdersFilter(e)
    let searchData = {
      ...this.props.filter,
      NewOrdersFilter: newOrdersFilter
    }
    this.props.setOrdersFilter(searchData, 'orderlist')
    this.setState({
      newOrdersFilter: newOrdersFilter
    })
    if (e) {
      searchData = {
        ...searchData,
        Steps: [1]
      }

      var spinner = document.createElement('i')
      spinner.className = 'fa fa-spinner fa-spin fa-2x fa-fw'
      spinner.style = 'margin-left: 82px; position: absolute;'
      var formElement = document.getElementById('newOrdersFilterId')
      formElement.firstChild.disabled = true
      formElement.insertBefore(spinner, formElement.firstChild)

      this.props.getOrdersNew(searchData).then((res) => {
        let steps = res.data[0].Steps
        let orders = JSON.parse(JSON.stringify(this.props.orders))
        orders[1].Orders = steps[1].Orders
        this.props.updateOrderList(orders)

        formElement.firstElementChild.remove()
        formElement.firstChild.disabled = false
      })
    }
  }
  renderHeader (header, key) {
    const orderGroupKey = key
    key += ' 234'
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    let iswp = hasAccess([6], this.props.auth.user.UserType)
    let isBodyShop = this.props.auth.user.DepartmentType > 0
    let isNewOrder = header.DictionaryKey === 164
    if (header.Orders.length === 0) {
      if (header.DictionaryKey === 164) {
        if (this.props.filter === undefined) return
        if (this.props.filter.NewOrdersFilter === undefined ||
          this.props.filter.NewOrdersFilter === null ||
          this.props.filter.NewOrdersFilter === 0) {
          return
        }
      } else {
        return
      }
    }
    const renderNewOrderOrInspection = () => {
      if (!hasSubscriptionPermission(this.props.auth, 10) && !isBodyShop) return null
      if (hasAccess([3, 7], this.props.auth.user.UserType)) {
        if (header.Title !== '0' && header.Title !== '1') {
          return (
            <div className='times'>
              {this.props.auth.departmentType !== 1 && (
                <div className='hint--bottom' aria-label={translation('13423')}>
                  <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/Inspectionsteps-black.svg' className='icon' />
                </div>
              )}

              {this.props.auth.departmentType === 1 && (
                <div>
                  <div style={{ width: 25, height: 25 }} className='icon' />
                </div>
              )}
            </div>
          )
        }
      }
      return (
        <div className='times'>
          <div className='hint--bottom' aria-label={isBodyShop ? translation('14827') : translation('157')}>
            <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/pick-up-time.svg' className='icon' />
          </div>
        </div>
      )
    }

    const renderRekvNr = () => {
      return (
        <div className='rekv_top_icon hint--top' aria-label={translation('1337')}>
          <img src='/images/svgs/ordrer/Requisition_No.svg' style={{ width: 25, height: 25 }} />
        </div>
      )
    }

    const renderRekvNrCol = () => {
      if (isBodyShop || hasSubscriptionPermission(this.props.auth, 10)) {
        return ([
          <div className='rekv_nr' >
            {renderRekvNr()}
          </div>,
          <div className='divider' />
        ])
      } else {
        return null
      }
    }

    const renderDraftorNot = (isDraft) => {
      let tooltip = isDraft === true ? translation('13522') : translation('1799')
      return (
        <div className='times'>
          <div className='hint--bottom' aria-label={tooltip}>
            <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/order-date.svg' className='icon' />
          </div>
        </div>
      )
    }
    const renderNewOrderFilter = () => {
      return (
        <form id='newOrdersFilterId'>
          <DropDown size='m' disabled={this.state.NewOrdersFilterIsLoading} onChange={this.setNewOrdersFilter.bind(this)} value={this.state.newOrdersFilter}>
            <option value={1}>{translation('238')}</option>
            <option value={2}>{translation('796')}</option>
            <option value={3}>{translation('797')}</option>
            <option value={4}>{translation('798')}</option>
            <option value={0}>{translation('381')}</option>
          </DropDown>
        </form>
      )
    }

    const showMassInvoiceModal = () => {
      this.props.triggerPopup(!this.state.massInvoice.open)
      this.setState({
        massInvoice: {
          ...this.state.massInvoice,
          open: true,
          orderGroup: header,
          orderGroupKey
        }
      })
    }

    let bodyClass = ' body'
    let nameClass = 'name'
    let rightClass = 'rightorder'
    if (isNewOrder) {
      rightClass += ' text-adjust'
      if (isCustomer) {
        rightClass += ' customer'
      }
    }
    let newOrdersHeaderClass = 'newOrderHeaderFilter'
    if (isBodyShop) {
      nameClass += bodyClass
      rightClass += bodyClass
    }
    if (!isBodyShop) {
      bodyClass = ''
    }
    if (iswp) {
      bodyClass = ' wp'
      nameClass += bodyClass
      rightClass += bodyClass
    }
    if (this.props.auth.departmentType !== 0) {
      if (isCustomer) {
        newOrdersHeaderClass += ' bodyCustomer'
      } else {
        newOrdersHeaderClass += ' extra'
      }
    } else if (isCustomer) {
      newOrdersHeaderClass += ' customer'
    } else if (iswp) {
      newOrdersHeaderClass += ' wp'
    }
    let isDraft = header.DictionaryKey === 395
    if (header.DictionaryKey === 395) { // 395 ordrekladder
      return (
        <div className='neworder_item-outer list__header' key={key}>
          <div className='neworder_item clearfix'>
            <div className={nameClass}>
              {this.getHeaderIcon(header)}
              <span>{translation(header.DictionaryKey)}</span>
            </div>
            <div className={rightClass}>
              <div className='divider' />
              {renderRekvNrCol()}
              <div className='message_missing_color' />
              <div className='divider' />
              <div className='times_wrap'>
                {isCustomer || iswp ? (
                  renderDraftorNot(isDraft)
                ) : (
                  <Grid>
                    <div className='times'>
                      <div className='hint--bottom' aria-label={isBodyShop ? translation('14827') : translation('157')}>
                        <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/pick-up-time.svg' className='icon' />
                      </div>
                    </div>
                    <div className='times'>
                      <div className='hint--bottom' aria-label={translation('193')}>
                        <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/Handsover-New.svg' className='icon' />
                      </div>
                    </div>
                  </Grid>
                )}
              </div>
              {hasSubscriptionPermission(this.props.auth, 20) && (<div className='divider' key='circle_1' />)}
              {(!isBodyShop || isBodyShop && hasSubscriptionPermission(this.props.auth, 20)) && (<div className='circle' key='circle_2' />)}
              {this.props.auth.departmentType !== 0 && (
                <span>
                  <div className='divider' />
                  <div className='body_paint_status' />
                </span>
              )}
              <div className='divider' />
              <div className='transport' />
              <div className='divider' />
              {!isCustomer && (
                <div className='invoice' />
              )}
              {!isCustomer && (
                <div className='divider' />
              )}
              <div className={'price_and_action' + bodyClass} />
            </div>
          </div>
        </div>
      )
    } else if (header.DictionaryKey === 2703 || header.DictionaryKey === 2702) { // 2702 afsluttede (denne uge) // 2703 afsluttede (resterende)
      return (
        <div className='neworder_item-outer list__header' key={key}>
          <div className='neworder_item clearfix'>
            <div className={nameClass}>
              {this.getHeaderIcon(header)}
              <span>{translation(header.DictionaryKey)}</span>
              {!isCustomer && (
                <div className='invoice invoice__show' onClick={showMassInvoiceModal}>
                  <div className='hint--top' aria-label={'Mass invoice'}>
                    <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/mass-invoicing2.svg' className='icon' />
                  </div>
                </div>
              )}
            </div>
            <div className={rightClass}>
              <div className='divider' />
              {renderRekvNrCol()}
              <div className='message_missing_color' />
              <div className='divider' />
              <div className='times_wrap'>
                {renderNewOrderOrInspection()}
                {hasAccess([3, 7], this.props.auth.user.UserType) && (
                  <div className='times'>
                    <div className='hint--bottom' aria-label={translation('1231')}>
                      <img style={{ width: 25, height: 25 }} src='/images/svgs/workscreen/Completed-Black.svg' className='icon' />
                    </div>
                  </div>
                )}
                {!(!hasSubscriptionPermission(this.props.auth, 10) && !(this.props.auth.departmentType === 1)) && (
                  <div className='times'>
                    <div className='hint--bottom' aria-label={translation('193')}>
                      <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/Handsover-New.svg' className='icon' />
                    </div>
                  </div>
                )}
              </div>
              {hasSubscriptionPermission(this.props.auth, 20) && (<div className='divider' key='circle_1' />)}
              {(!isBodyShop || isBodyShop && hasSubscriptionPermission(this.props.auth, 20)) && (<div className='circle' key='circle_2' />)}
              {this.props.auth.departmentType !== 0 && (
                <span>
                  <div className='divider' />
                  <div className='body_paint_status' />
                </span>
              )}
              <div className='divider' />
              <div className='transport' />
              <div className='divider' />
              {!isCustomer && (
                <div className='invoice'>
                  {hasSubscriptionPermission(this.props.auth, 10) && (<div className='hint--top' aria-label={'Mass invoice'} onClick={showMassInvoiceModal}>
                    <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/mass-invoicing2.svg' className='icon' />
                  </div>)}
                </div>
              )}
              {!isCustomer && (
                <div className='divider' />
              )}
              <div className={'price_and_action' + bodyClass} />
            </div>
          </div>
        </div>
      )
    } else {
      let newOrdersSpacerBefore = 'space-adjust-before'
      let newOrdersSpacerAfter = 'space-adjust-after'
      if (this.props.auth.departmentType !== 0) {
        newOrdersSpacerBefore += ' bodyshop-spacer'
        newOrdersSpacerAfter += ' bodyshop-spacer'
      } else if (iswp) {
        newOrdersSpacerBefore += ' wp-spacer'
      }
      if (!hasSubscriptionPermission(this.props.auth, 20)) {
        newOrdersSpacerBefore += ' minimal'
      }
      let newOrderHeader = isNewOrder ? 'neworder_header-title' : ''
      let cols = iswp ? [0.7, 0.7, 0.7] : [0.7, 1]
      return (
        <div className='neworder_item-outer list__header' key={key}>
          <div className='neworder_item clearfix'>
            <div className={nameClass}>
              {this.getHeaderIcon(header)}
              <span className={newOrderHeader}>{translation(header.DictionaryKey)}</span>
              {isNewOrder && (
                renderNewOrderFilter()
              )}
              {!isCustomer && (
                <div className='invoice invoice__show' onClick={showMassInvoiceModal}>
                  <div className='hint--top' aria-label={'Mass invoice'}>
                    <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/mass-invoicing2.svg' className='icon' />
                  </div>
                </div>
              )}
            </div>
            <div className={rightClass}>
              <div className='divider' />
              {renderRekvNrCol()}
              <div className='message_missing_color' />
              <div className='divider' />
              <div className='times_wrap'>
                {!(hasSubscriptionPermission(this.props.auth, 10)) && !isBodyShop && renderDraftorNot(isDraft)}
                <Grid cols={cols}>
                  {!(this.props.auth.departmentType === 1 && header.DictionaryKey === 161) && renderNewOrderOrInspection()}
                  {this.props.auth.departmentType === 1 && header.DictionaryKey === 161 && (
                    <div className='times'>
                      <div className='hint--bottom' aria-label={translation('14982')}>
                        <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/coating-done-5.svg' className='icon' />
                      </div>
                    </div>
                  )}
                  {(iswp && header.DictionaryKey !== 161) && (
                    <div className='times'>
                      <div className='hint--bottom' aria-label={translation('13423')}>
                        <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/Inspectionsteps-black.svg' className='icon' />
                      </div>
                    </div>
                  )}
                  {((hasSubscriptionPermission(this.props.auth, 10) && !isBodyShop) || isBodyShop) && (
                    <div className='times'>
                      <div className='hint--bottom' aria-label={translation('193')}>
                        <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/Handsover-New.svg' className='icon' />
                      </div>
                    </div>
                  )}
                </Grid>
              </div>
              {!isNewOrder && hasSubscriptionPermission(this.props.auth, 20) && (<div className='divider' key='circle_1' />)}
              {!isNewOrder && (!isBodyShop || isBodyShop && hasSubscriptionPermission(this.props.auth, 20)) && (<div className='circle' key='circle_2' />)}
              {!isNewOrder && this.props.auth.departmentType !== 0 && (
                <span>
                  <div className='divider' />
                  <div className='body_paint_status' />
                </span>
              )}
              {!isNewOrder && (<div className='divider' />)}
              {!isNewOrder && (<div className='transport' />)}
              {!isNewOrder && (<div className='divider' />)}
              {isNewOrder && (
                <div className={newOrdersHeaderClass}>
                  {renderNewOrderFilter()}
                </div>
              )}
              {isNewOrder && (<div className={newOrdersSpacerBefore} />)}
              {!isCustomer && (
                <div className='invoice'>
                  {hasSubscriptionPermission(this.props.auth, 10) && (<div className='hint--top' aria-label={'Mass invoice'} onClick={showMassInvoiceModal}>
                    <img style={{ width: 25, height: 25 }} src='/images/svgs/listheader/mass-invoicing2.svg' className='icon' />
                  </div>)}
                </div>
              )}
              {isNewOrder && (<div className={newOrdersSpacerAfter} />)}
              {!isNewOrder && !isCustomer && (
                <div className='divider' />
              )}
              {!isNewOrder && (<div className={'price_and_action' + bodyClass} />)}
            </div>
          </div>
        </div>
      )
    }
  }

  renderMassInvoiceModal () {
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    const { open, isLoading, response, itemsIsInvoicing } = this.state.massInvoice
    const iswp = hasAccess([6], this.props.auth.user.UserType)

    const orderKeys = {}
    const addToOrderKeys = (valid, o, groupKey, orderKey) => {
      if (valid) {
        orderKeys[groupKey] = [...orderKeys[groupKey] || [], { Id: o.Id, orderKey }]
      }
    }

    const readyOrders = this.props.orders.reduce((filtered, orderGroup, groupKey) => {
      const readyForInvoice = orderGroup.Orders.filter((o, orderKey) => {
        let mayInvoice = false
        if (iswp) {
          mayInvoice = !o.IsInvoicedByWP && !o.IsMarkInvoicedByWP
        } else {
          mayInvoice = !o.IsInvoiced && !o.IsMarkInvoiced
        }

        const valid = o.ReadyForInvoice === 1 && mayInvoice
        addToOrderKeys(valid, o, groupKey, orderKey)
        return valid
      })

      const readyForMark = orderGroup.Orders.filter((o, orderKey) => {
        let mayMarkInvoiced = false
        if (iswp) {
          mayMarkInvoiced = /* o.IsInvoicedByWP && */ !o.IsMarkInvoicedByWP
        } else {
          mayMarkInvoiced = /* o.IsInvoiced && */ !o.IsMarkInvoiced
        }

        const valid = o.ReadyForInvoice === 1 && mayMarkInvoiced
        addToOrderKeys(valid, o, groupKey, orderKey)
        return valid
      })

      if (readyForInvoice.length !== 0) {
        filtered.readyForInvoice.push({
          StepId: orderGroup.StepId,
          DictionaryKey: orderGroup.DictionaryKey,
          orders: readyForInvoice
        })
      }
      if (readyForMark.length !== 0) {
        filtered.readyForMark.push({
          StepId: orderGroup.StepId,
          DictionaryKey: orderGroup.DictionaryKey,
          orders: readyForMark
        })
      }

      return filtered
    }, { readyForInvoice: [], readyForMark: [] })

    return (
      <MassInvoice
        onClose={this.onMassInvoiceClose}
        show={open}
        isLoading={isLoading}
        orders={readyOrders.readyForInvoice}
        invoicedOrders={readyOrders.readyForMark}
        executeMassInvoice={this.executeMassInvoice}
        response={response}
        getHeaderIcon={this.getHeaderIcon}
        meta={{ orderKeys }}
        itemsIsInvoicing={itemsIsInvoicing}
        getErrDictionaryKey={this.getMassInvoiceErrorKey}
      />
    )
  }

  getMassInvoiceErrorKey (errorType) {
    switch (errorType) {
      case 0:
        return '13700'
      case 1:// OrderNotFound = 1,
        return '13701'
      case 2:// CompanyNotFound = 2,
        return '13702'
      case 3:// NotValidEconomicCredentials = 3,
        return '13703'
      case 4:// NotValidHeliosNumber = 4,
        return '13704'
      case 5:// NotValidC5UserPass = 5,
        return '13705'
      case 6:// OrderIsAlreadySent = 6,
        return '13706'
      case 7:
        return '13707'
      case 8:// AwaitingPriceApproval = 8
        return '2710'
      case 9:
        return '14851'
      case 10:// NoDepartmentNumber = 10
        return '16616'
      case 11:// NoDepartmentNumberEconomic = 11
        return '16617'
      default:
        return '960'
    }
  }

  executeMassInvoice (selectedOrders, action, splitAddon, { orderKeys }) {
    const ids = selectedOrders.map(o => o.Id)

    const updateOrders = (orders) => {
      // update orders in the orderlist
      orders.forEach(order => {
        const keys = Object.entries(orderKeys).reduce((keys, ok) => {
          const [groupKey, orderKeys] = ok
          const orderKey = orderKeys.find(k => k.Id === order.Id)

          if (orderKey) {
            return [parseInt(groupKey), orderKey.orderKey]
          }
          return keys
        }, [])

        if (keys.length === 2) {
          this.props.updateOrderListSingle(order, keys[0], keys[1])
        }
      })
    }

    this.setState({
      massInvoice: {
        ...this.state.massInvoice,
        isLoading: true,
        itemsIsInvoicing: ids
      }
    }, () => {
      // Is Invoicing
      const key = `ItemsIsInvoicing_${this.props.auth.user.UserId}`
      // const isLoadings = JSON.parse(window.localStorage.getItem(key)) || []
      // const isInvoicing = JSON.stringify([...isLoadings, ...ids])
      // window.localStorage.setItem(key, isInvoicing) // Gives problems when invoicing and leaving page, orders are never removed from as invoicing

      updateOrders(selectedOrders)

      if (action !== 1) {
        this.props.massInvoiceOrders({
          OrderIds: ids,
          SplitAddon: splitAddon,
          MarkAsInvoiced: action === 2
        })
          .then(res => {
            const { Success, Errors } = res.data
            let errors = false

            if (Errors.length > 0) {
              errors = Errors.map(e => {
                let errDictionaryKey = this.getMassInvoiceErrorKey(e.Error)

                return { order: e.order, error: translation(errDictionaryKey) }
              })

              const errorText = errors.map(e => {
                const identification = e.order.RegNumber || e.order.Id
                return `${identification}: ${e.error}<br />`
              })

              window.toastr.error(errorText, translation('216'))
            }

            window.localStorage.removeItem(key)

            this.setState({
              massInvoice: {
                ...this.state.massInvoice,
                isLoading: false,
                itemsIsInvoicing: [],
                response: { action, success: Success, errors }
              }
            })

            // update icons in the orderlist
            // updateOrders([ ...Success, ...Errors.map(e => e.order)])

            if (Errors.length === 0) {
              if (action === 2) {
                // window.toastr.success(translation('14992'), translation('13424'))
              } else {
                // window.toastr.success(translation('14990'), translation('13424'))
              }
            }
          })
          .catch(() => {
            window.localStorage.removeItem(key)
            // updateOrders(selectedOrders)
            window.toastr.error(translation('960'), translation('216'))

            this.setState({
              massInvoice: {
                ...this.state.massInvoice,
                isLoading: false,
                itemsIsInvoicing: [],
                response: { action, errors: true }
              }
            })
          })
      } else {
        this.props.massMarkInvoiced({
          OrderIds: ids
        })
          .then(res => {
            this.setState({
              massInvoice: {
                ...this.state.massInvoice,
                isLoading: false,
                itemsIsInvoicing: [],
                response: { action, success: res.data }
              }
            })

            window.localStorage.removeItem(key)
            // window.toastr.success(translation('14991'), translation('13424'))

            // update icons in the orderlist
            // updateOrders(res.data)
          })
          .catch(() => {
            this.setState({
              massInvoice: {
                ...this.state.massInvoice,
                isLoading: false,
                itemsIsInvoicing: [],
                response: { action, errors: true }
              }
            })

            window.localStorage.removeItem(key)
            window.toastr.error(translation('960'), translation('216'))
          })
      }
    })
  }

  onMassInvoiceClose () {
    this.props.triggerPopup(false)
    this.setState({
      massInvoice: {
        ...this.state.massInvoice,
        open: false,
        isLoading: false,
        response: null
      }
    })
  }

  renderItems () {
    if (this.props.errors && !this.props.isLoading) {
      return (
        <div className='loading'>
          <div />
          {translation('960')}
        </div>
      )
    }

    if (this.props.orders.length === 0 || this.props.isLoading) {
      return (
        <div className='loading'>
          <div />
          <div className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <span className='sr-only'>{translation('13382')}...</span>
          </div>
        </div>
      )
    }

    const listContent = this.props.orders.map((orderGroup, key) => {
      if (!orderGroup.SkipCheck) {
        if (!this.props.filter.process.draft && orderGroup.DictionaryKey === 395) {
          return null
        }
        if (!this.props.filter.process.Completed && orderGroup.DictionaryKey === 23) {
          return null
        }
        if (!this.props.filter.process.InProcess) {
          let inprocess = [1, 2, 3, 4, 5, 6, 7]
          if (inprocess.indexOf(parseInt(orderGroup.Title)) !== -1) {
            return null
          }
        }
      }

      let orders = ''
      if (orderGroup.Orders.length === 0) {

      } else {
        orders = orderGroup.Orders.map((this.renderItem.bind(this, key)))
      }
      return ([
        this.renderHeader(orderGroup, key),
        orders
      ])
    })

    return listContent
  }

  renderItem (index, key) {
    return this.state.items[index]
  }

  render () {
    let listClass = ''
    if (this.props.auth.user.CustomerId !== '-1') {
      listClass = 'client__list'
    } else {
      listClass = 'work__list'
    }

    if (this.state.assignBoxOut) {
      listClass += ' assignBoxOut'
    }

    if (this.props.errors && !this.props.isLoading) {
      let text = translation('960')
      if (this.props.errors.NoOrders === true) {
        text = translation('957')
      }

      return (
        <div className={'orderlist__list ' + listClass}>
          <div className='loading'>
            <div />
            {text}
          </div>
        </div>
      )
    }

    if (this.state.items.length === 0 || this.props.isLoading) {
      return (
        <div className={'orderlist__list ' + listClass}>
          <div className='loading'>
            <div />
            <div className='animated-background'>
              <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
              <span className='sr-only'>{translation('13382')}...</span>
            </div>
          </div>
        </div>
      )
    }
    let threshold = 200
    const goToTop = () => {
      this.app.scrollTop = 0
      this.setState({
        GoToTop: false
      })
    }
    return (
      <div className={'orderlist__list ' + listClass}>
        <ReactList
          ref='reactlist'
          itemRenderer={this.renderItem}
          length={this.state.items.length}
          pageSize={this.number}
          threshold={threshold}
          type='simple' />
        {this.state.GoToTop && (
          <div className='orderScrollToTop' onClick={goToTop.bind(this)}>
            <img src='/images/svgs/go-to-top.svg' alt='Scroll til toppen' title={translation('13025')} />
          </div>
        )}

        {this.state.massInvoice.open && this.renderMassInvoiceModal()}
      </div>
    )
  }
}

function mapStateToProps (state) {
  let filter = state.orders.filterOrderlist
  if (hasAccess([4], state.auth.user.UserType)) {
    filter = state.orders.filterCustomer
  } else if (hasAccess([6], state.auth.user.UserType)) {
    filter = state.orders.filterWP
  }
  return {
    auth: state.auth,
    filter: filter,
    orders: state.orders.orders
  }
}

export default connect(mapStateToProps, {
  getArchivedOrders,
  updateOrderList,
  getOrdersNew,
  setOrdersFilter,
  updateOrderListSingle,
  massInvoiceOrders,
  massMarkInvoiced,
  triggerPopup
}, null, { withRef: true })(List)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/List/index.js